import { Link, useNavigate } from 'react-router-dom';
import { ChevronLeft, Compass } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { useStore } from '../store/StoreContext';

// App.tsx's catch-all ("*") route, deliberately outside RequireGuest/
// RequireAuth and AppLayout's sidebar chrome - same reasoning as the legal
// pages and PublicChannelViewScreen, since an unmatched URL can be hit by
// anyone regardless of session state. Used to silently redirect to "/"; now
// shows an actual page instead, matching zmist's own visual language
// (LegalScreen's shell: logo header, themed (--color-bg) background, AppFooter).
export function NotFoundScreen() {
  const navigate = useNavigate();
  const { isLoggedIn } = useStore();

  return (
    <div className="min-h-screen w-full bg-[var(--color-bg)] flex flex-col">
      <header className="flex items-center gap-3 px-4 sm:px-6 py-4 max-w-2xl mx-auto w-full">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <img src="/zmist-logo.svg" alt="Zmist" className="w-8 h-8" />
          <span className="text-[15px] font-semibold">Zmist</span>
        </Link>
      </header>

      <main className="flex-1 flex flex-col items-center justify-center text-center px-4 gap-3 -mt-16 md:pb-14">
        <Compass size={36} strokeWidth={1.5} className="text-black/30 dark:text-white/30" />
        <div className="text-6xl font-bold tracking-tight">404</div>
        <h1 className="text-xl font-semibold">Nothing here</h1>
        <p className="text-sm text-black/50 dark:text-white/50 max-w-xs">
          This page doesn't exist, or it moved. Check the link, or head back.
        </p>
        <div className="flex items-center gap-3 mt-3">
          <Button variant="bordered" onClick={() => navigate(-1)}>
            <ChevronLeft size={16} /> Back
          </Button>
          <Button variant="primary" onClick={() => navigate(isLoggedIn ? '/channels' : '/start')}>
            {isLoggedIn ? 'Go to channels' : 'Go to zmist'}
          </Button>
        </div>
      </main>
    </div>
  );
}
